<footer class="pda-footer">
    <div class="text-center pda-footer-title">
        <h2 class="pda-title">
            <span class="pda-title-1">Allegra</span>
            <span class="pda-title-2">&nbsp;Pole Dance</span>
        </h2>
    </div>
    <div class="text-center">
        <h3 class="pda-footer-text-reserve">Reserva tus clases</h3>
    </div>
    <div class="text-center">
        <p class="pda-footer-wellcome-text">Bienvenidos a nuestra escuela de poledance.</p>
    </div>
    <div class="text-center">
        <span class="pda-footer-call-text">Ll&aacute;manos:</span>
        <a href="tel:993465968" class="pda-footer-call-number">&nbsp;993465968</a>
    </div>
    <div class="text-center">
        <a class="pda-btn primary" href="tel:993465968">
            Cont&aacute;ctanos
        </a>
    </div>
    <div class="text-center">
        <ul class="pda-footer-social-media">
            <li>
                <a class="pda-footer-social-media-icon" href="https://www.facebook.com/Poledanceperuallegra" target="_blank">
                    <i class="bi bi-facebook"></i>
                </a>
            </li>
            <li>
                <a class="pda-footer-social-media-icon" href="https://www.instagram.com/allegra_pole/" target="_blank">
                    <i class="bi bi-instagram"></i>
                </a>
            </li>
            <li>
                <a class="pda-footer-social-media-icon" href="https://api.whatsapp.com/send?phone=+51993465968" target="_blank">
                    <i class="bi bi-whatsapp"></i>
                </a>
            </li>
        </ul>
    </div>
</footer>